import { Component, OnInit, Input } from '@angular/core';
import { Const } from '../../shared';

@Component({
  selector: 'iw-elements-helper',
  templateUrl: './elements-helper.component.html',
  styleUrls: ['./elements-helper.component.scss']
})
export class ElementsHelperComponent implements OnInit {

  // Muestra u oculta las ayudas
  @Input() show = false;
  // Define si se esta trabajando con una instancia o un trámite por default
  @Input() isInstance = true;
  cssStatus = Const.CSS_STATUS;
  statusActivity = Const.STATUS_ACTIVITY;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/elements-helper/elements-helper.component.ts